export class BankDetailsModel {
	bankAccountName?: string;
	bankAccountNameError?: string;
	bankName?: string;
	bankNameError?: string;
	accountNumber?: string;
	accountNumberError?: string;
	sortCode?: string;
	sortCodeError?: string;
	niNumber?: string;
	niNumberError?: string;
	jobOp1?: boolean;
	jobOp1Error?: string;
	jobOp2?: boolean;
	jobOp2Error?: string;
	jobOp3?: boolean;
	jobOp3Error?: string;
	studentLoan?: IStudentLoan;
	studentLoanError?: string;

	constructor(data: any = {}) {
		this.bankAccountName = data.bankAccountName || "";
		this.bankName = data.bankName || "";
		this.accountNumber = data.accountNumber || "";
		this.sortCode = data.sortCode || "";
		this.niNumber = data.niNumber || "";
		this.jobOp1 = data.jobOp1 !== null && data.jobOp1 !== undefined ? data.jobOp1 : null;
		this.jobOp2 = data.jobOp2 !== null && data.jobOp2 !== undefined ? data.jobOp2 : null;
		this.jobOp3 = data.jobOp3 !== null && data.jobOp3 !== undefined ? data.jobOp3 : null;
		this.studentLoan = data.studentLoan || null;
	}
}

export interface IStudentLoan {
	studentLoan: boolean;
	plan1: boolean;
	plan2: boolean;
	plan4: boolean;
	postGradLoan: boolean;
}

export interface IStudentLoanErrors {
	studentLoanError?: string;
}

export class StudentLoanModel implements IStudentLoan {
	studentLoan: boolean;
	plan1: boolean;
	plan2: boolean;
	plan4: boolean;
	postGradLoan: boolean;

	constructor(data?: IStudentLoan) {
		this.studentLoan = data?.studentLoan === true || data?.studentLoan === false ? data.studentLoan : null;
		this.plan1 = data?.plan1 !== null && data?.plan1 !== undefined ? data.plan1 : null;
		this.plan2 = data?.plan2 !== null && data?.plan2 !== undefined ? data.plan2 : null;
		this.plan4 = data?.plan4 !== null && data?.plan4 !== undefined ? data.plan4 : null;
		this.postGradLoan = data?.postGradLoan !== null && data?.postGradLoan !== undefined ? data.postGradLoan : null;
	}
}

export class StudentLoanErrorsModel implements IStudentLoanErrors {
	studentLoanError?: string;

	constructor(data?: IStudentLoanErrors) {
		this.studentLoanError = data?.studentLoanError ?? null;
	}
}
